import { useContext, createContext, ReactNode } from "react"

import { APP_STATUSES } from "utils/AppStatusContext"

const CurrentStatusContext = createContext<APP_STATUSES>(undefined!)

interface Props {
    children: ReactNode
    value: APP_STATUSES
}

export function CurrentStatusProvider({ children, value }: Props) {
    return <CurrentStatusContext.Provider value={value}>{children}</CurrentStatusContext.Provider>
}

export const useCurrentStatus = () => useContext(CurrentStatusContext)
